import { Navigate } from "react-router-dom";
import useAuth from "./Auth";

const PrivateRoute = ({ children }) => {
  const auth = useAuth();

  if (auth === null) return <p>Loading...</p>;
  return auth ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
